import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import colors from "../../config/colors";
import NtBadge from "../../components/NtBadge";
import NtModal from "../../components/NtModal";
import NtCallingRatesUpdateForm from "./NtCallingRatesUpdateForm";
import {
  parseDecimalPlaces,
  parseSimpleDisplayDate,
} from "../../common/utils/ControllerUtils";
import NtListRow from "../../components/NtListRow";
import currencydata from "../data/currencydata";
import { fetchCurrency } from "../utils/CurrencyParser";
import { usePermission } from "../../hooks/usePermission";
import routes from "../../navigation/routes";
import settings from "../../config/settings";

function NtCallingRatesItem({ item, columns, onUpdate }) {
  const updateModalRef = useRef();
  const permission = usePermission(
    settings.permissionTypeEdit,
    routes.callingrate
  );

  const currency = fetchCurrency(item.currency);

  const renderUpdateForm = () => {
    return (
      <NtModal ref={updateModalRef}>
        <NtCallingRatesUpdateForm
          item={item}
          onCancel={() => {
            updateModalRef.current?.dismiss();
          }}
          onUpdate={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(item, column) => {
          if (column == "status") {
            const active = item[column] == 1;
            return (
              <NtBadge variant={active ? "green" : "gray"}>
                {active ? "Active" : "Inactive"}
              </NtBadge>
            );
          } else if (column == "price" || column == "cost") {
            return `${currency?.symbol}${parseDecimalPlaces(item[column])}`;
          } else if (column == "creationdate") {
            return parseSimpleDisplayDate(item[column]);
          } else if (column == "creationdate") {
            return parseSimpleDisplayDate(item[column]);
          }
        }}
        onActionPress={
          permission
            ? () => {
                updateModalRef?.current?.show();
              }
            : null
        }
      />
      {renderUpdateForm()}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  text: {
    fontSize: 12,
    fontWeight: "700",
    color: colors.lighGray,
  },
});

export default NtCallingRatesItem;
